// Framework
import { Component, OnInit } from '@angular/core';

// Providers
import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-success200',
	templateUrl: './success200.component.html',
})
export class Success200Component implements OnInit{

	url: string = ""

	constructor(private dataSvc: DataService) {
		this.url = this.getCPLink();
	}

	ngOnInit() {
		this.dataSvc.saveItemToSessionStorage("isComplete", true);
	}

	getCPLink(): string {
		return "https://" + this.dataSvc.daycare.alias + ".childpilot.com";
	}

	openUrl(url: string) {
		window.open(url, "_system");
	}

}
